export default {
  name: "Group",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M12.9 20.3c.73-.76 1.18-1.78 1.18-2.91 0-2.32-1.89-4.21-4.2-4.21s-4.2 1.89-4.2 4.21c0 1.13.45 2.16 1.18 2.91-1.87.88-3.67 2.7-3.86 6.11v.05c0 .85.69 1.54 1.53 1.54h10.68c.87 0 1.53-.66 1.53-1.59-.18-3.41-1.98-5.23-3.84-6.11zm-5.23-2.91c0-1.22.99-2.21 2.2-2.21s2.2.99 2.2 2.21-.99 2.2-2.2 2.2-2.2-.99-2.2-2.2zM5.04 26c.52-4.24 4.38-4.41 4.83-4.41.46 0 4.34.17 4.84 4.41H5.04zm20.07-14.92a4.17 4.17 0 0 0 1.17-2.89C26.28 5.88 24.4 4 22.09 4S17.9 5.88 17.9 8.19c0 1.12.45 2.14 1.17 2.89-1.86.88-3.64 2.69-3.83 6.08v.05c0 .84.69 1.53 1.53 1.53h10.62c.87 0 1.53-.66 1.53-1.59-.17-3.38-1.96-5.19-3.81-6.07zm-5.2-2.89a2.19 2.19 0 1 1 4.379-.001 2.19 2.19 0 0 1-4.379.001zm-2.62 8.56c.52-4.21 4.35-4.37 4.79-4.37.45 0 4.31.17 4.81 4.37h-9.6z",
  },
}
